import {Trans} from '@ui/i18n/trans';

/**
 * "N days left" for a deadline countdown — one wording everywhere.
 *
 * - 0 reads "Closes today". A bare count rendered "0 days left" on the last
 *   day ("باقٍ 0 يوم"), which looked closed and wrong.
 * - The count goes through a plural message keyed on `count`, so Arabic can
 *   give the right noun form for 1, 2, 3–10 and 11+ instead of one "يوم" for
 *   every number (see handlePluralMessage).
 */
export const DAYS_LEFT_MESSAGE = '[one 1 day left|other :count days left]';

export function DaysLeft({days}: {days: number}) {
  if (days <= 0) return <Trans message="Closes today" />;
  return <Trans message={DAYS_LEFT_MESSAGE} values={{count: days}} />;
}
